// Megamenu: hover interaction + clickable parent items

document.addEventListener('DOMContentLoaded', function() {
  syncHeaderBottomCssVar();
  initMegaMenuHover();
  initPromoDrag();
  initPromoArrows();
});

function syncHeaderBottomCssVar() {
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;
  document.documentElement.style.setProperty(
    '--header-bottom-position-desktop',
    `${Math.floor(headerWrapper.getBoundingClientRect().bottom)}px`
  );
}

window.addEventListener('resize', syncHeaderBottomCssVar);

(function() {
  const headerObserver = new MutationObserver(() => {
    initMegaMenuHover();
    initPromoDrag();
    initPromoArrows();
  });

  const header = document.querySelector('.header-wrapper') || document.querySelector('header');
  if (header) {
    headerObserver.observe(header, { childList: true, subtree: true });
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      initMegaMenuHover();
      initPromoDrag();
    });
  }
})();

function initMegaMenuHover() {
  const megaMenus = document.querySelectorAll('.header__inline-menu .mega-menu');

  megaMenus.forEach(menu => {
    if (menu.dataset.hoverInit) return;
    menu.dataset.hoverInit = 'true';

    const summary = menu.querySelector('summary');
    const headerMenu = menu.closest('header-menu');
    if (!summary) return;

    let closeTimeout = null;

    if (headerMenu) {
      headerMenu.onFocusOut = function() {};
    }

    menu.addEventListener('mouseenter', function() {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
      megaMenus.forEach(m => {
        if (m !== menu) m.removeAttribute('open');
      });
      menu.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', function() {
      closeTimeout = setTimeout(() => {
        menu.removeAttribute('open');
      }, 150);
    });

    summary.addEventListener('click', function(e) {
      const span = e.target.closest('span');
      if (span) {
        const url = summary.getAttribute('data-link-url');
        if (url && url !== '#' && url !== '') {
          window.location.href = url;
          return;
        }
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);

    summary.addEventListener('mousedown', function(e) {
      e.preventDefault();
    }, true);
  });
}

function initPromoDrag() {
  const promos = document.querySelectorAll('.mega-menu__promo');

  promos.forEach(el => {
    if (el.dataset.dragInit) return;
    el.dataset.dragInit = 'true';

    el.addEventListener('dragstart', e => e.preventDefault());

    let isDragging = false;
    let startX = 0, startScroll = 0;
    let velX = 0, lastX = 0, lastTime = 0;
    let rafId = null;

    el.addEventListener('mousedown', e => {
      if (e.button !== 0) return;

      // If press starts on a link or image, leave it 100% alone — no drag intercept
      if (e.target.closest('a')) return;

      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
      isDragging = false;
      startX = e.pageX;
      startScroll = el.scrollLeft;
      velX = 0; lastX = e.pageX; lastTime = Date.now();

      function onMove(me) {
        const dx = me.pageX - startX;
        if (!isDragging && Math.abs(dx) < 4) return;
        if (!isDragging) {
          isDragging = true;
          el.classList.add('is-dragging');
        }
        const now = Date.now();
        const dt = now - lastTime;
        if (dt > 0) velX = (me.pageX - lastX) / dt;
        lastX = me.pageX; lastTime = now;
        el.scrollLeft = startScroll - dx;
      }

      function onUp() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        el.classList.remove('is-dragging');
        if (!isDragging) return;
        isDragging = false;
        let velocity = -velX * 40;
        const friction = 0.94;
        (function momentum() {
          if (Math.abs(velocity) < 0.5) return;
          el.scrollLeft += velocity;
          velocity *= friction;
          rafId = requestAnimationFrame(momentum);
        })();
      }

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  });
}


function initPromoArrows() {
  const containers = document.querySelectorAll('.mega-menu__promo-container');
  containers.forEach(container => {
    if (container.dataset.arrowsInit) return;
    container.dataset.arrowsInit = 'true';

    const promo = container.querySelector('.mega-menu__promo');
    const prevBtn = container.querySelector('.mega-menu__promo-arrow--prev');
    const nextBtn = container.querySelector('.mega-menu__promo-arrow--next');
    if (!promo || !prevBtn || !nextBtn) return;

    const updateArrowState = () => {
      const maxScroll = promo.scrollWidth - promo.clientWidth;
      const atStart = promo.scrollLeft <= 5;
      const atEnd = promo.scrollLeft >= maxScroll - 5;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      if (atStart) prevBtn.classList.add('is-disabled');
      else prevBtn.classList.remove('is-disabled');
      if (atEnd) nextBtn.classList.add('is-disabled');
      else nextBtn.classList.remove('is-disabled');
    };

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const step = 200;
      promo.scrollBy({ left: -step, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const step = 200;
      promo.scrollBy({ left: step, behavior: 'smooth' });
    });

    promo.addEventListener('scroll', updateArrowState, { passive: true });
    updateArrowState();
    setTimeout(updateArrowState, 300);

    const menu = container.closest('.mega-menu');
    if (menu) {
      menu.addEventListener('mouseenter', () => {
        setTimeout(updateArrowState, 50);
      });
    }
  });
}
